// Add your custom JS here.
ScrollReveal().reveal('.reveal', { duration: 1000, distance: '150px'  })

ScrollReveal().reveal('.sr1', { duration: 1200, distance: '200px' })
ScrollReveal().reveal('.sr2', { duration: 1400, distance: '300px' })
ScrollReveal().reveal('.sr3', { duration: 1600, distance: '400px' })

ScrollReveal().reveal('.sr1d', { origin: 'right',duration: 6000, distance: '200px' })
ScrollReveal().reveal('.sr2d', { origin: 'right',duration: 7000, distance: '300px' })
ScrollReveal().reveal('.sr3d', { origin: 'right',duration: 8000, distance: '400px' })

ScrollReveal().reveal('.srl', { origin: 'left', duration: 2500, distance: '600px' });
ScrollReveal().reveal('.srr', { origin: 'right', duration: 2500, distance: '600px' })
